export function isAction(a) {
    return a && a.type !== undefined;
}
export function isActions(actions) {
    return Array.isArray(actions) && actions.every(isAction);
}
export function enter() {
    return {
        type: "Enter",
    };
}
export function exit() {
    return {
        type: "Exit",
    };
}
export function onFrame() {
    return {
        type: "OnFrame",
    };
}
export const nextFrame = onFrame;
export function onTick() {
    return {
        type: "OnTick",
    };
}
export const nextTick = onTick;
// Helper for making simple actions.
export function typedAction(type) {
    return () => ({
        type,
    });
}
//# sourceMappingURL=action.js.map